import { createFeatureSelector, createSelector } from '@ngrx/store';
import { List } from 'immutable';
import { handleActions } from 'redux-actions';
import {
  ActionsEnum,
  IFetchPayPalTransactionHistory,
  IFetchPayPalTransactionHistorySuccess,
} from './payments-data.actions';
import { PayPalTransactionItem } from './payments-data.data';

// feature name
export const FEATURE_NAME = 'payments-data';

// state definition
export interface IState {
  payPalTransactionHistory: List<PayPalTransactionItem>;
  loadingPayPalTransactionHistory: boolean;
  payPalTransactionHistoryNextPageTimestamp: string;
}

// initial state
export const initialState: IState = {
  payPalTransactionHistory: List<PayPalTransactionItem>([]),
  loadingPayPalTransactionHistory: false,
  payPalTransactionHistoryNextPageTimestamp: null,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.FETCH_PAYPAL_TRANSACTION_HISTORY]: function (
      state: IState,
      { payload }: IFetchPayPalTransactionHistory
    ): IState {
      return {
        ...state,
        loadingPayPalTransactionHistory: true,
        payPalTransactionHistory: payload.timestamp
          ? state.payPalTransactionHistory
          : List<PayPalTransactionItem>([]),
      };
    },
    [ActionsEnum.FETCH_PAYPAL_TRANSACTION_HISTORY_SUCCESS]: function (
      state: IState,
      { payload }: IFetchPayPalTransactionHistorySuccess
    ): IState {
      return {
        ...state,
        loadingPayPalTransactionHistory: false,
        payPalTransactionHistory: List<PayPalTransactionItem>([
          ...state.payPalTransactionHistory.toArray(),
          ...payload.transactions.toArray(),
        ]),
        payPalTransactionHistoryNextPageTimestamp: payload.nextPageTimestamp,
      };
    },
    [ActionsEnum.FETCH_PAYPAL_TRANSACTION_HISTORY_ERROR]: function (
      state: IState
    ): IState {
      return {
        ...state,
        loadingPayPalTransactionHistory: false,
      };
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selector
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getPayPalTransactionHistory = createSelector(
  selectFeature,
  (state: IState) => state.payPalTransactionHistory
);

export const getLoadingPayPalTransactionHistory = createSelector(
  selectFeature,
  (state: IState) => state.loadingPayPalTransactionHistory
);

export const getPayPalTransactionHistoryNextPageTimestamp = createSelector(
  selectFeature,
  (state: IState) => state.payPalTransactionHistoryNextPageTimestamp
);
